
export const text = `

[ID: A photo of some sheets of paper. They are littered over a very disorganized table; napkins stained with coffee and cigarrette bums are strewn all over. The leftmost papers read about various forms of fractal sets. Meanwhile, those on the right have pictures of religious statues. There are lines drawn in red marker attempting to connect the concepts, somehow.]

`